'use client';
import { WizardAnimationWrapper } from '@/components/WizardAnimationWrapper';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { EMAIL_REGEX } from '@treyd-io/core/constants/regex';
import ArrowLeftIcon from '@treyd-io/treyd-ui/icons/ArrowLeftIcon';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

const INITIAL_VALUES = {
  email: '',
};

interface ForgotPasswordProps {
  onNext: boolean;
  onMovingBackward: () => void;
  onMovingForward: (values: typeof INITIAL_VALUES) => void;
}
export const ForgotPassword = (props: ForgotPasswordProps) => {
  const { onNext, onMovingBackward, onMovingForward } = props;
  const { t } = useTranslation();

  return (
    <Stack>
      <WizardAnimationWrapper onNext={onNext}>
        <Stack width="100%" maxWidth={368} gap={3} alignItems="flex-start">
          <Button
            color="info"
            startIcon={<ArrowLeftIcon />}
            onClick={onMovingBackward}>
            {t('back')}
          </Button>
          <Stack gap={2}>
            <Typography variant="h3" color="text.primary">
              {t('reset_password')}
            </Typography>
            <Typography variant="body1" color="text.primary">
              {t('reset_password_subtitle')}
            </Typography>
          </Stack>
          <Formik
            initialValues={INITIAL_VALUES}
            onSubmit={onMovingForward}
            validationSchema={yup.object({
              email: yup
                .string()
                .required(t('email_is_required'))
                .trim()
                .matches(EMAIL_REGEX, t('invalid_email_address')),
            })}>
            {(formik) => (
              <Form style={{ width: '100%' }} noValidate>
                <Stack gap={3}>
                  <TextField
                    fullWidth
                    name="email"
                    label={t('email')}
                    type="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                  <Button
                    variant="contained"
                    size="large"
                    fullWidth
                    type="submit">
                    {t('send_link')}
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>
        </Stack>
      </WizardAnimationWrapper>
    </Stack>
  );
};
